import { Box, Heading } from '@weareberyl/design-system'
import { LoadingComponent } from '~/components/Query/utils'
import { useUserSchemesQuery } from '~/gql/generated/graphql'
import SchemeButton from './SchemeButton'

const UserSchemes = ({ userId }: { userId: string }) => {
  const { data, loading } = useUserSchemesQuery({
    variables: { userId },
    pollInterval: 0,
  })

  return (
    <>
      <Heading mb={1}>Active in schemes:</Heading>
      <Box
        flexDirection="column"
        flexWrap="wrap"
        style={{ gap: 3 }}
        maxHeight={250}
      >
        {!data && loading && <LoadingComponent />}
        {data?.user?.user_schemes.map(({ scheme, scheme_id }) =>
          scheme ? (
            <SchemeButton
              scheme={{ ...scheme, id: scheme_id }}
              key={scheme_id}
            />
          ) : null,
        )}
      </Box>
      {/* </Flex> */}
    </>
  )
}

export default UserSchemes
